<div class="layout-xl is-gap-4">
  <form [formGroup]="form">
    <h2>{{ 'tarificateur.title' | translate }}</h2>
    <p>{{ 'tarificateur.subtitle' | translate }}</p>
    <acs-product-option-section
      [fc]="currencyOptionFC"
      [authorizedCfe]="isAuthorizedCfe()">
    </acs-product-option-section>
    <acs-hospitalisation-evacuation-option-section
      [fc]="hospitalisationEvacuationOptionFC">
    </acs-hospitalisation-evacuation-option-section>
    <mat-divider></mat-divider>
    <acs-medical-care-option-section
      [fc]="medicalCareOptionFC"
      [options]="options.medicaux">
    </acs-medical-care-option-section>
    <acs-dental-optical-option-section
      [fc]="dentalOptionFC"
      [options]="options.dentaire">
    </acs-dental-optical-option-section>
    @if ($isMaternityCompatible()) {
      <acs-maternity-option-section
        [options]="options.maternite"
        [fc]="maternityOptionFC"
        [beneficiariesFC]="beneficiariesFC"
        [sectionDisabled]="expatProjectMaternityOptionCtrl.value === '0'"
        [optionsPopulate]="maternityOptionPopulate">
      </acs-maternity-option-section>
    }
    <acs-assistance-plus-option-section
      [fc]="assistancePlusOptionFC">
    </acs-assistance-plus-option-section>
    <acs-deductible-option-section [fc]="deductibleOptionFC">
    </acs-deductible-option-section>
    <mat-divider />
    <acs-payment-frequency-option-section
      [fc]="periodicityPaymentOptionFC"
      [periodicity]="$periodicityPricing()">
    </acs-payment-frequency-option-section>
    <acs-cover-zone-option-section
      [expatAdditionalCountryFC]="expatAdditionalCountryFC"
      [expatCoverNationalityCountryFC]="expatCoverNationalityCountryFC"
      [coverageZone]="$coverageZone()"
      [alreadyCovered]="$expatPricing().already_covered_in_origin_country"
      [addCountries]="addCountries"
      [addCountriesOptions]="filteredCountries">
    </acs-cover-zone-option-section>

    <div
      class="form-actions is-flex is-align-items-center is-justify-content-center gap-xs mt-5">
      @if (!$isLoading()) {
        <button
          mat-stroked-button
          color="secondary"
          class="is-flex-grow-1"
          (click)="save()"
          type="button"
          [disabled]="form.invalid || $isLoading()">
          {{ 'key.save' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          class="is-flex-grow-1"
          (click)="submit()"
          type="button"
          [disabled]="form.invalid || $isLoading()">
          {{ 'key.subscribe' | translate }}
        </button>
      } @else {
        <button
          mat-flat-button
          class="is-flex-grow-1"
          type="button"
          [disabled]="true">
          <mat-icon class="is-size-5 loading" style="height: 20px; width: 24px">
            refresh
          </mat-icon>
        </button>
      }
    </div>
  </form>
  <!-- Zone en bas avec résumé des informations. -->
  <div class="bottom-resume is-flex mobile-only">
    <div class="amount is-flex is-flex-direction-column is-align-items-center">
      @if (!$isLoading()) {
        <span class="is-size-5 has-text-weight-bold">
          {{ $price().price | currencyFormat }}
        </span>
        <span class="is-size-7">{{ $price().frequency | translate }}</span>
      } @else {
        <span class="is-size-5 has-text-weight-bold loading">
          <mat-icon>refresh</mat-icon>
        </span>
      }
    </div>
    <div class="has-text-weight-semibold">
      {{ 'tarificateur.custom.offer' | translate }}
    </div>
    <button
      mat-icon-button
      class="mobile-only"
      (click)="openBottomSheet()"
      attr.aria-label="{{ 'tarificateur.resum.panel' | translate }}"
      type="button">
      <mat-icon>arrow_drop_up</mat-icon>
    </button>
  </div>
  <div class="bottom-resume is-flex-direction-column is-flex desktop-only mt-5">
    <div class="is-flex is-align-items-center">
      <div
        class="amount is-flex is-flex-direction-column is-align-items-center">
        @if (!$isLoading()) {
          <span class="is-size-5 has-text-weight-bold">
            {{ $price().price | currencyFormat }}
          </span>
          <span class="is-size-7">{{ $price().frequency | translate }}</span>
        } @else {
          <span class="is-size-5 mt-4 has-text-weight-bold loading">
            <mat-icon>refresh</mat-icon>
          </span>
        }
      </div>
      <div class="has-text-weight-semibold ml-4">
        {{ 'tarificateur.custom.offer' | translate }}
      </div>
    </div>
    @if (!$isLoading()) {
      <app-acs-tarifs-resume></app-acs-tarifs-resume>
    }
  </div>
</div>
